export default class EditorHelpers {
    constructor() {
    }
    /**
     * Function to fix encoding issues in strings that contain special characters
     * This function is useful when you have a string that contains special characters like quotes, dashes, ellipsis, etc.
     * @param {string} str - The string to fix
     * @returns {string} - The fixed string
     * */
    static fixEncoding(str) {
        //console.log(str);
        // Define replacements in an array of objects
        const replacements = [
            { regex: /â€™|â€\x99/g, replacement: "’" }, // Closing single quote
            { regex: /â€˜/g, replacement: "‘" }, // Opening single quote

            // Double quotes
            { regex: /â€œ/g, replacement: "“" }, // Opening double quote
            { regex: /â€/g, replacement: "”" }, // Closing double quote

            // Other replacements
            { regex: /â€”/g, replacement: '—' }, // Em dash
            { regex: /â€“/g, replacement: '–' }, // En dash
            { regex: /â€¦/g, replacement: '…' }, // Ellipsis
            { regex: /â€¢/g, replacement: '•' }  // Bullet
        ];

        // Check if the string contains any of the symbols we want to replace
        if (replacements.some(({ regex }) => str.search(regex) !== -1)) {
            // If so, apply all replacements
            replacements.forEach(({ regex, replacement }) => {
                str = str.replace(regex, replacement);
            });
        }
        //console.log(str);
        return str;
    }
}
